import { useTranslate } from "@refinedev/core";
import { Divider, Grid2 as Grid, Typography } from "@mui/material";

import { Form } from "@shared/components";

export function AcessControlFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 18, color: "primary.main" }}>
          {translate("v1/agreement_admin.titles.acess_control")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="user_limit"
          label={translate("v1/agreement_admin.fields.user_limit")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="promocode_limit"
          label={translate("v1/agreement_admin.fields.promocode_limit")}
          mask="number"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>
    </Grid>
  );
}
